/* App config for apis
 */

const ApiConstants = {
  BASE_URL: 'https://sop.chboston.org/sop2apigateway/so/api/',
  BASE_IMAGE_URL: 'https://sop.chboston.org/sop2apigateway/images/',
  TERMS_CONDITIONS_URL:
    'https://sop.chboston.org/sop2apigateway/images/MYCTermsandConditions.pdf',
  IPAPI_URL: 'https://ipapi.co/json/'
};

export default ApiConstants;
